import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';
import { useFeatureNutrition } from 'hooks/use-feature-nutrition';

import { NutritionTable } from './nutrition-table';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

type NutritionProps = {
  nutritionInfo: INutritionInfo;
};

export const Nutrition: React.FC<NutritionProps> = ({ nutritionInfo }) => {
  const { nutritionTables, roundNutritionValue, featureNutritionLoading } = useFeatureNutrition();

  if (featureNutritionLoading || !nutritionTables.length) {
    return null;
  }

  return (
    <Container data-testid="nutrition-v2">
      {nutritionTables.map(
        (table, index) =>
          table && (
            <NutritionTable
              key={table._key || index}
              nutritionInfo={nutritionInfo}
              nutritionTable={table}
              roundNutritionValue={roundNutritionValue}
            />
          )
      )}
    </Container>
  );
};
